class StickyCartBar extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this._syncSeq = 0;

    this.onCartUpdate = this.syncVisibility.bind(this);

    window.addEventListener("cart:added", this.onCartUpdate);
    window.addEventListener("cart:changed", this.onCartUpdate);
    window.addEventListener("cart:rendered", this.onCartUpdate);

    this.syncVisibility();
  }

  disconnectedCallback() {
    window.removeEventListener("cart:added", this.onCartUpdate);
    window.removeEventListener("cart:changed", this.onCartUpdate);
    window.removeEventListener("cart:rendered", this.onCartUpdate);
  }

  getCartCountFromBadge() {
    const badge = document.querySelector("[data-badge='cart']");
    if (!badge) return null;
    const raw = badge.getAttribute("data-count") ?? badge.textContent;
    const count = Number(raw);
    return Number.isFinite(count) ? count : null;
  }

  async fetchCartCount() {
    const cartUrl =
      document.querySelector("cart-component")?.dataset?.routeCart ||
      this.dataset.cartUrl ||
      "/cart";
    const response = await fetch(`${String(cartUrl).replace(/\/$/, "")}.js`, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Unable to read cart");
    const cart = await response.json();
    return Number(cart.item_count || 0);
  }

  applyVisibility(count) {
    const next = Math.max(0, Number(count) || 0);
    this.dataset.itemCount = String(next);
    if (next > 0) {
      this.setAttribute("data-visible", "true");
    } else {
      this.removeAttribute("data-visible");
    }
  }

  async syncVisibility(event) {
    const seq = ++this._syncSeq;

    try {
      // Prefer the event payload — available on cart:added / cart:changed.
      if (event?.detail && event.detail.item_count != null) {
        if (seq !== this._syncSeq) return;
        this.applyVisibility(event.detail.item_count);
        return;
      }

      // Badge is updated in the same paint as bulk qty / ATC section refresh.
      const badgeCount = this.getCartCountFromBadge();
      if (badgeCount != null) {
        if (seq !== this._syncSeq) return;
        this.applyVisibility(badgeCount);
        return;
      }

      // Fallback: hit cart.js directly (don't depend on cart-component upgrade timing).
      const count = await this.fetchCartCount();
      if (seq !== this._syncSeq) return;
      this.applyVisibility(count);
    } catch (error) {
      console.error(error);
      if (seq !== this._syncSeq) return;
      // On error after a cart event, hide rather than keep a stale open bar.
      if (event) this.applyVisibility(0);
    }
  }
}

customElements.define("sticky-cart-bar", StickyCartBar);
